module.exports = __webpack_public_path__ + "static/photo-dfd654387f734b93bfdc13479a0b106b.jpg";